var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BattlesList',{attrs:{"id":_vm.accountId,"type":_vm.accountType,"list-type":_vm.valueModel}})}
var staticRenderFns = []

export { render, staticRenderFns }